import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';

interface IStudentAuthContainerProps {
  children: React.ReactNode;
}

const StudentAuthContainer = ({ children }: IStudentAuthContainerProps) => {
  const dispatch: AppDispatch = useDispatch();
  const navigateTo = useNavigate();
  const studentTokenAuth = useSelector((state: RootState) => state.user.studentTokenAuth);

  useEffect(() => {
    if (studentTokenAuth === null) {
      navigateTo('/auth/student');
    }
  }, []);

  return <>{children}</>;
};

export default StudentAuthContainer;
